







import Vue from 'vue';
import Component from 'vue-class-component';
import AppSession from '@/store/AppSession';

declare const appProp: any;
@Component
export default class ChatBotButton extends Vue {
  public onClickChatBot() {
    const origin = appProp.origin;
    const accessToken = AppSession.getAccessToken()!;
    const height = window.outerHeight >= 1000 ? 850 : 784;
    const newTab = window.open(``, 'chatbot', `toolbar=yes,scrollbars=0,resizable=0,top=0,left=0,width=460,height=${height}}`);
    const params = {
      accessToken,
      language: this.$route.params.language,
      appendix: this.$route.params.appendix,
      senderKey: this.$route.params.senderKey ?? -1,
    };
    newTab!.location.href
      = `${origin}/open-api/v1.1/chatbot?${new URLSearchParams(params).toString()}`;
  }
}
